<template>
  <div class="room dehumidifier-room" v-loading="loadingData">
    <div class="dehumidifier-main">
      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop1" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop10" :series="switchDataTop10" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop1A" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop11" :series="switchDataTop11" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop12" :series="switchDataTop12" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop13" :series="switchDataTop13" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop1B" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop14" :series="switchDataTop14" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop15" :series="switchDataTop15" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop16" :series="switchDataTop16" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop1C" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop17" :series="switchDataTop17" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop18" :series="switchDataTop18" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop19" :series="switchDataTop19" />
        </div>
        <!-- <div class="column-line-XS">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown1" :bold="true" />
        </div> -->
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop2" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop20" :series="switchDataTop20" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop2A" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop21" :series="switchDataTop21" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop22" :series="switchDataTop22" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop23" :series="switchDataTop23" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop2B" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop24" :series="switchDataTop24" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop25" :series="switchDataTop25" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop26" :series="switchDataTop26" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop2C" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop27" :series="switchDataTop27" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop28" :series="switchDataTop28" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop29" :series="switchDataTop29" />
        </div>
        <!-- <div class="column-line-XS">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown2" :bold="true" />
        </div> -->
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-XL">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop3" :bold="true" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop3A" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop31" :series="switchDataTop31" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop32" :series="switchDataTop32" />
          <SwitchStatus class="switch-item" :title="switchTitleTop33" :series="switchDataTop33" />
          <SwitchStatus class="switch-item" :title="switchTitleTop34" :series="switchDataTop34" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop35" :series="switchDataTop35" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop3B" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop36" :series="switchDataTop36" />
          <SwitchStatus class="switch-item" :title="switchTitleTop38" :series="switchDataTop38" />
          <SwitchStatus class="switch-item" :title="switchTitleTop37" :series="switchDataTop37" />
        </div>
        <div class="column-line-XS">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown3" :bold="true" />
          <!-- <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop3C" :bold="true" /> -->
          <SwitchStatusValue class="switch-item" :title="switchTitleDown30" :series="switchDataDown30" />
          <SwitchStatus class="switch-item" :title="switchTitleDown31" :series="switchDataDown31" />
          <SwitchStatus class="switch-item" :title="switchTitleDown32" :series="switchDataDown32" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown33" :series="switchDataDown33" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-S">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop4" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop41" :series="switchDataTop41" />
          <SwitchStatus class="switch-item" :title="switchTitleTop42" :series="switchDataTop42" />
          <SwitchStatus class="switch-item" :title="switchTitleTop43" :series="switchDataTop43" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop44" :series="switchDataTop44" />
        </div>
        <div class="column-line-L">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown4" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown41" :series="switchDataDown41" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown42" :series="switchDataDown42" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown43" :series="switchDataDown43" />
          <SwitchStatus class="switch-item" :title="switchTitleDown44" :series="switchDataDown44" />
          <SwitchStatus class="switch-item" :title="switchTitleDown45" :series="switchDataDown45" />
          <SwitchStatus class="switch-item" :title="switchTitleDown46" :series="switchDataDown46" />
          <!-- <SwitchStatus class="switch-item" :title="switchTitleDown47" :series="switchDataDown47" /> -->
          <SwitchStatusValue class="switch-item" :title="switchTitleDown48" :series="switchDataDown48" />
        </div>
      </div>
    </div>

    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
  </div>
</template>

<script>
import configJson from "./config/station.json";

export default {
  name: "tower",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: "",
      stationName: "",
      stationIndex: "",
      stationVentNameFix: "",

      exitGasClampListDict: {
        "1出口": ["A1", "A2"],
      },

      switchDataTop10: null,
      switchDataTop11: null,
      switchDataTop12: null,
      switchDataTop13: null,
      switchDataTop14: null,
      switchDataTop15: null,
      switchDataTop16: null,
      switchDataTop17: null,
      switchDataTop18: null,
      switchDataTop19: null,

      switchDataTop20: null,
      switchDataTop21: null,
      switchDataTop22: null,
      switchDataTop23: null,
      switchDataTop24: null,
      switchDataTop25: null,
      switchDataTop26: null,
      switchDataTop27: null,
      switchDataTop28: null,
      switchDataTop29: null,

      switchDataTop31: null,
      switchDataTop32: null,
      switchDataTop33: null,
      switchDataTop34: null,
      switchDataTop35: null,
      switchDataTop36: null,
      switchDataTop37: null,
      switchDataTop38: null,
      switchDataDown30: null,
      switchDataDown31: null,
      switchDataDown32: null,
      switchDataDown33: null,

      switchDataTop41: null,
      switchDataTop42: null,
      switchDataTop43: null,
      switchDataTop44: null,

      switchDataDown41: null,
      switchDataDown42: null,
      switchDataDown43: null,
      switchDataDown44: null,
      switchDataDown45: null,
      switchDataDown46: null,
      switchDataDown47: null,
      switchDataDown48: null,

      deviceList: [],
    };
  },
  computed: {
    columnTitleTop1: function () {
      return this.stationName + "-混合送风段";
    },
    columnTitleTop1A: function () {
      return this.stationIndex + "-1高压出口";
    },
    columnTitleTop1B: function () {
      return this.stationIndex + "-2高压出口";
    },
    columnTitleTop1C: function () {
      return this.stationIndex + "-3高压出口";
    },
    columnTitleTop2: function () {
      return this.stationName + "-混合送风段";
    },
    columnTitleTop2A: function () {
      return this.stationIndex + "-4高压出口";
    },
    columnTitleTop2B: function () {
      return this.stationIndex + "-5高压出口";
    },
    columnTitleTop2C: function () {
      return this.stationIndex + "-6高压出口";
    },
    columnTitleTop3: function () {
      return this.stationName + "-再生段";
    },
    columnTitleTop3A: function () {
      return "再生加热";
    },
    columnTitleTop3B: function () {
      return "再生排风";
    },
    columnTitleTop3C: function () {
      return "再生转轮";
    },
    columnTitleTop4: function () {
      return this.stationName + "-控制箱";
    },

    columnTitleDown1: function () {
      return this.stationName + "-混合段";
    },
    columnTitleDown2: function () {
      return this.stationName + "-混合段";
    },
    columnTitleDown3: function () {
      return this.stationName + "-转轮除湿段";
    },
    columnTitleDown4: function () {
      return this.stationName + "-表冷段";
    },

    switchTitleTop10: function () {
      return "回风";
    },
    switchTitleTop11: function () {
      return this.stationIndex + "-1高压风机";
    },
    switchTitleTop12: function () {
      return this.stationIndex + "-1高压出口";
    },
    switchTitleTop13: function () {
      return this.stationIndex + "-1高压出口";
    },
    switchTitleTop14: function () {
      return this.stationIndex + "-2高压风机";
    },
    switchTitleTop15: function () {
      return this.stationIndex + "-2高压出口";
    },
    switchTitleTop16: function () {
      return this.stationIndex + "-2高压出口";
    },
    switchTitleTop17: function () {
      return this.stationIndex + "-3高压风机";
    },
    switchTitleTop18: function () {
      return this.stationIndex + "-3高压出口";
    },
    switchTitleTop19: function () {
      return this.stationIndex + "-3高压出口";
    },

    switchTitleTop20: function () {
      return "设定";
    },
    switchTitleTop21: function () {
      return this.stationIndex + "-4高压风机";
    },
    switchTitleTop22: function () {
      return this.stationIndex + "-4高压出口";
    },
    switchTitleTop23: function () {
      return this.stationIndex + "-4高压出口";
    },
    switchTitleTop24: function () {
      return this.stationIndex + "-5高压风机";
    },
    switchTitleTop25: function () {
      return this.stationIndex + "-5高压出口";
    },
    switchTitleTop26: function () {
      return this.stationIndex + "-5高压出口";
    },
    switchTitleTop27: function () {
      return this.stationIndex + "-6高压风机";
    },
    switchTitleTop28: function () {
      return this.stationIndex + "-6高压出口";
    },
    switchTitleTop29: function () {
      return this.stationIndex + "-6高压出口";
    },

    switchTitleTop31: function () {
      return "再生加热";
    },
    switchTitleTop32: function () {
      return "再生加热设定";
    },
    switchTitleTop33: function () {
      return "再生加热";
    },
    switchTitleTop34: function () {
      return "再生加热超温";
    },
    switchTitleTop35: function () {
      return "再生加热";
    },
    switchTitleTop36: function () {
      return "再生排风";
    },
    switchTitleTop37: function () {
      return "再生风机过载";
    },
    switchTitleTop38: function () {
      return "再生排风超温";
    },
    switchTitleDown30: function () {
      return "送风";
    },
    switchTitleDown31: function () {
      return "再生转轮";
    },
    switchTitleDown32: function () {
      return "减速机过载";
    },
    switchTitleDown33: function () {
      return "再生转轮";
    },

    switchTitleTop41: function () {
      return "除湿机组";
    },
    switchTitleTop42: function () {
      return "报警";
    },
    switchTitleTop43: function () {
      return "电源故障";
    },
    switchTitleTop44: function () {
      return "除湿机组";
    },

    switchTitleDown41: function () {
      return "前表";
    },
    switchTitleDown42: function () {
      return "前表盘管";
    },
    switchTitleDown43: function () {
      return "前表设定";
    },
    switchTitleDown44: function () {
      return "前表";
    },
    switchTitleDown45: function () {
      return "前表化霜";
    },
    switchTitleDown46: function () {
      return "前表保护";
    },
    // switchTitleDown47: function () {
    //   return "前表高压";
    // },
    switchTitleDown48: function () {
      return "前表";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
      this.warningFlag1 = "";
      this.warningFlag2 = "";
      this.warningFlag3 = "";
      this.warningFlag4 = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    assembleExitGasClamp(exitName) {
      let gasClampName = "";
      if (exitName && this.exitGasClampListDict[exitName]) {
        let gasClampList = this.exitGasClampListDict[exitName];
        for (let gasClamp of gasClampList) {
          if (gasClampName !== "") {
            gasClampName += ", ";
          }
          gasClampName += gasClamp;
        }
      }

      let result = exitName + "连接气夹: " + gasClampName;
      return result;
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();
      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationId = configJson[routerName].stationId;
      this.stationIndex = configJson[routerName].stationIndex;
      this.stationVentNameFix = configJson[routerName].stationVentNameFix;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      // this.getLineChartData();

      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        const currentData = res.data;

        const switchIdTop10T = this.findDeviceId(this.switchTitleTop10 + "温度");
        const switchIdTop10H = this.findDeviceId(this.switchTitleTop10 + "湿度");
        const switchIdTop10A = this.findDeviceId(this.switchTitleTop10 + "含湿量");
        const switchIdTop11 = this.findDeviceId(this.switchTitleTop11.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "过载");
        const switchIdTop11B = this.findDeviceId(this.switchTitleTop11.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "运行");
        const switchIdTop12T = this.findDeviceId(this.switchTitleTop12.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "温度");
        const switchIdTop12H = this.findDeviceId(this.switchTitleTop12.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "湿度");
        const switchIdTop12A = this.findDeviceId(this.switchTitleTop12.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "含湿量");
        const switchIdTop13P = this.findDeviceId(this.switchTitleTop13.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "压力");
        const switchIdTop13F = this.findDeviceId(this.switchTitleTop13.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "风速");
        const switchIdTop14 = this.findDeviceId(this.switchTitleTop14.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "过载");
        const switchIdTop14B = this.findDeviceId(this.switchTitleTop14.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "运行");
        const switchIdTop15T = this.findDeviceId(this.switchTitleTop15.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "温度");
        const switchIdTop15H = this.findDeviceId(this.switchTitleTop15.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "湿度");
        const switchIdTop15A = this.findDeviceId(this.switchTitleTop15.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "含湿量");
        const switchIdTop16P = this.findDeviceId(this.switchTitleTop16.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "压力");
        const switchIdTop16F = this.findDeviceId(this.switchTitleTop16.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "风速");
        const switchIdTop17 = this.findDeviceId(this.switchTitleTop17.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "过载");
        const switchIdTop17B = this.findDeviceId(this.switchTitleTop17.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "运行");
        const switchIdTop18T = this.findDeviceId(this.switchTitleTop18.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "温度");
        const switchIdTop18H = this.findDeviceId(this.switchTitleTop18.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "湿度");
        const switchIdTop18A = this.findDeviceId(this.switchTitleTop18.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "含湿量");
        const switchIdTop19P = this.findDeviceId(this.switchTitleTop19.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "压力");
        const switchIdTop19F = this.findDeviceId(this.switchTitleTop19.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "风速");

        this.switchDataTop10 = [
          {
            data: currentData[switchIdTop10T].value,
            isError: currentData[switchIdTop10T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop10H].value,
            isError: currentData[switchIdTop10H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop10A].value,
            isError: currentData[switchIdTop10A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop11 = [
          {
            data: currentData[switchIdTop11].value,
            isError: currentData[switchIdTop11].errorLevel,
            isZh: true,
          },
          {
            data: currentData[switchIdTop11B].value,
            isError: currentData[switchIdTop11B].errorLevel,
          },
        ];
        this.switchDataTop12 = [
          {
            data: currentData[switchIdTop12T].value,
            isError: currentData[switchIdTop12T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop12H].value,
            isError: currentData[switchIdTop12H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop12A].value,
            isError: currentData[switchIdTop12A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop13 = [
          {
            data: currentData[switchIdTop13P].value,
            isError: currentData[switchIdTop13P].errorLevel,
            unit: "KPa",
          },
          {
            data: currentData[switchIdTop13F].value,
            isError: currentData[switchIdTop13F].errorLevel,
            unit: "m/s",
          },
        ];
        this.switchDataTop14 = [
          {
            data: currentData[switchIdTop14].value,
            isError: currentData[switchIdTop14].errorLevel,
            isZh: true,
          },
          {
            data: currentData[switchIdTop14B].value,
            isError: currentData[switchIdTop14B].errorLevel,
          },
        ];
        this.switchDataTop15 = [
          {
            data: currentData[switchIdTop15T].value,
            isError: currentData[switchIdTop15T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop15H].value,
            isError: currentData[switchIdTop15H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop15A].value,
            isError: currentData[switchIdTop15A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop16 = [
          {
            data: currentData[switchIdTop16P].value,
            isError: currentData[switchIdTop16P].errorLevel,
            unit: "KPa",
          },
          {
            data: currentData[switchIdTop16F].value,
            isError: currentData[switchIdTop16F].errorLevel,
            unit: "m/s",
          },
        ];
        this.switchDataTop17 = [
          {
            data: currentData[switchIdTop17].value,
            isError: currentData[switchIdTop17].errorLevel,
            isZh: true,
          },
          {
            data: currentData[switchIdTop17B].value,
            isError: currentData[switchIdTop17B].errorLevel,
          },
        ];
        this.switchDataTop18 = [
          {
            data: currentData[switchIdTop18T].value,
            isError: currentData[switchIdTop18T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop18H].value,
            isError: currentData[switchIdTop18H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop18A].value,
            isError: currentData[switchIdTop18A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop19 = [
          {
            data: currentData[switchIdTop19P].value,
            isError: currentData[switchIdTop19P].errorLevel,
            unit: "KPa",
          },
          {
            data: currentData[switchIdTop19F].value,
            isError: currentData[switchIdTop19F].errorLevel,
            unit: "m/s",
          },
        ];

        const switchIdTop20T = this.findDeviceId("温度" + this.switchTitleTop20);
        const switchIdTop20H = this.findDeviceId("湿度" + this.switchTitleTop20);
        const switchIdTop21 = this.findDeviceId(this.switchTitleTop21.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "过载");
        const switchIdTop21B = this.findDeviceId(this.switchTitleTop21.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "运行");
        const switchIdTop22T = this.findDeviceId(this.switchTitleTop22.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "温度");
        const switchIdTop22H = this.findDeviceId(this.switchTitleTop22.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "湿度");
        const switchIdTop22A = this.findDeviceId(this.switchTitleTop22.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "含湿量");
        const switchIdTop23P = this.findDeviceId(this.switchTitleTop23.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "压力");
        const switchIdTop23F = this.findDeviceId(this.switchTitleTop23.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "风速");
        const switchIdTop24 = this.findDeviceId(this.switchTitleTop24.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "过载");
        const switchIdTop24B = this.findDeviceId(this.switchTitleTop24.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "运行");
        const switchIdTop25T = this.findDeviceId(this.switchTitleTop25.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "温度");
        const switchIdTop25H = this.findDeviceId(this.switchTitleTop25.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "湿度");
        const switchIdTop25A = this.findDeviceId(this.switchTitleTop25.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "含湿量");
        const switchIdTop26P = this.findDeviceId(this.switchTitleTop26.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "压力");
        const switchIdTop26F = this.findDeviceId(this.switchTitleTop26.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "风速");
        const switchIdTop27 = this.findDeviceId(this.switchTitleTop27.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "过载");
        const switchIdTop27B = this.findDeviceId(this.switchTitleTop27.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "运行");
        const switchIdTop28T = this.findDeviceId(this.switchTitleTop28.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "温度");
        const switchIdTop28H = this.findDeviceId(this.switchTitleTop28.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "湿度");
        const switchIdTop28A = this.findDeviceId(this.switchTitleTop28.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "含湿量");
        const switchIdTop29P = this.findDeviceId(this.switchTitleTop29.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "压力");
        const switchIdTop29F = this.findDeviceId(this.switchTitleTop29.replace(this.stationIndex + "-", "").replace("高压", "#高压") + "风速");

        this.switchDataTop20 = [
          {
            data: currentData[switchIdTop20T].value,
            isError: currentData[switchIdTop20T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop20H].value,
            isError: currentData[switchIdTop20H].errorLevel,
            unit: "%",
          },
        ];
        this.switchDataTop21 = [
          {
            data: currentData[switchIdTop21].value,
            isError: currentData[switchIdTop21].errorLevel,
            isZh: true,
          },
          {
            data: currentData[switchIdTop21B].value,
            isError: currentData[switchIdTop21B].errorLevel,
          },
        ];
        this.switchDataTop22 = [
          {
            data: currentData[switchIdTop22T].value,
            isError: currentData[switchIdTop22T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop22H].value,
            isError: currentData[switchIdTop22H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop22A].value,
            isError: currentData[switchIdTop22A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop23 = [
          {
            data: currentData[switchIdTop23P].value,
            isError: currentData[switchIdTop23P].errorLevel,
            unit: "KPa",
          },
          {
            data: currentData[switchIdTop23F].value,
            isError: currentData[switchIdTop23F].errorLevel,
            unit: "m/s",
          },
        ];
        this.switchDataTop24 = [
          {
            data: currentData[switchIdTop24].value,
            isError: currentData[switchIdTop24].errorLevel,
            isZh: true,
          },
          {
            data: currentData[switchIdTop24B].value,
            isError: currentData[switchIdTop24B].errorLevel,
          },
        ];
        this.switchDataTop25 = [
          {
            data: currentData[switchIdTop25T].value,
            isError: currentData[switchIdTop25T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop25H].value,
            isError: currentData[switchIdTop25H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop25A].value,
            isError: currentData[switchIdTop25A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop26 = [
          {
            data: currentData[switchIdTop26P].value,
            isError: currentData[switchIdTop26P].errorLevel,
            unit: "KPa",
          },
          {
            data: currentData[switchIdTop26F].value,
            isError: currentData[switchIdTop26F].errorLevel,
            unit: "m/s",
          },
        ];
        this.switchDataTop27 = [
          {
            data: currentData[switchIdTop27].value,
            isError: currentData[switchIdTop27].errorLevel,
            isZh: true,
          },
          {
            data: currentData[switchIdTop27B].value,
            isError: currentData[switchIdTop27B].errorLevel,
          },
        ];
        this.switchDataTop28 = [
          {
            data: currentData[switchIdTop28T].value,
            isError: currentData[switchIdTop28T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop28H].value,
            isError: currentData[switchIdTop28H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop28A].value,
            isError: currentData[switchIdTop28A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop29 = [
          {
            data: currentData[switchIdTop29P].value,
            isError: currentData[switchIdTop29P].errorLevel,
            unit: "KPa",
          },
          {
            data: currentData[switchIdTop29F].value,
            isError: currentData[switchIdTop29F].errorLevel,
            unit: "m/s",
          },
        ];

        const switchIdTop31 = this.findDeviceId(this.switchTitleTop31 + "温度");
        const switchIdTop32 = this.findDeviceId(this.switchTitleTop32.replace("设定", "温度设定"));
        const switchIdTop33 = this.findDeviceId(this.switchTitleTop33 + "保护");
        const switchIdTop33B = this.findDeviceId(this.switchTitleTop33 + "运行");
        const switchIdTop34 = this.findDeviceId(this.switchTitleTop34 + "报警");
        const switchIdTop35 = this.findDeviceId(this.switchTitleTop35 + "运行时间");
        const switchIdTop36 = this.findDeviceId(this.switchTitleTop36 + "温度");
        const switchIdTop37 = this.findDeviceId(this.switchTitleTop37);
        const switchIdTop38 = this.findDeviceId(this.switchTitleTop38 + "报警");

        this.switchDataTop31 = {
          data: currentData[switchIdTop31].value,
          isError: currentData[switchIdTop31].errorLevel,
          unit: "℃",
        };
        this.switchDataTop32 = {
          data: currentData[switchIdTop32].value,
          isError: currentData[switchIdTop32].errorLevel,
          unit: "℃",
        };
        this.switchDataTop33 = [
          {
            data: currentData[switchIdTop33].value,
            isError: currentData[switchIdTop33].errorLevel,
            isZh: true,
          },
          {
            data: currentData[switchIdTop33B].value,
            isError: currentData[switchIdTop33B].errorLevel,
          },
        ];
        this.switchDataTop34 = {
          data: currentData[switchIdTop34].value,
          isError: currentData[switchIdTop34].errorLevel,
          isZh: true,
        };
        this.switchDataTop35 = {
          data: currentData[switchIdTop35].value,
          isError: currentData[switchIdTop35].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop36 = {
          data: currentData[switchIdTop36].value,
          isError: currentData[switchIdTop36].errorLevel,
          unit: "℃",
        };
        this.switchDataTop37 = {
          data: currentData[switchIdTop37].value,
          isError: currentData[switchIdTop37].errorLevel,
          isZh: true,
        };
        this.switchDataTop38 = {
          data: currentData[switchIdTop38].value,
          isError: currentData[switchIdTop38].errorLevel,
          isZh: true,
        };

        const switchIdDown30 = this.findDeviceId(this.switchTitleDown30 + "温度");
        const switchIdDown30B = this.findDeviceId(this.switchTitleDown30 + "湿度");
        const switchIdDown30C = this.findDeviceId(this.switchTitleDown30 + "含湿量");
        const switchIdDown31 = this.findDeviceId(this.switchTitleDown31 + "运行");
        const switchIdDown32 = this.findDeviceId(this.switchTitleDown32);
        const switchIdDown33 = this.findDeviceId(this.switchTitleDown33 + "运行时间");
        this.switchDataDown30 = [
          {
            data: currentData[switchIdDown30].value,
            isError: currentData[switchIdDown30].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdDown30B].value,
            isError: currentData[switchIdDown30B].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdDown30C].value,
            isError: currentData[switchIdDown30C].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataDown31 = {
          data: currentData[switchIdDown31].value,
          isError: currentData[switchIdDown31].errorLevel,
        };
        this.switchDataDown32 = {
          data: currentData[switchIdDown32].value,
          isError: currentData[switchIdDown32].errorLevel,
          isZh: true,
        };
        this.switchDataDown33 = {
          data: currentData[switchIdDown33].value,
          isError: currentData[switchIdDown33].errorLevel,
          isRunningTime: true,
        };

        const switchIdTop41 = this.findDeviceId(this.switchTitleTop41.replace("除湿", "") + "运行");
        const switchIdTop42 = this.findDeviceId(this.switchTitleTop42 + "灯");
        const switchIdTop43 = this.findDeviceId(this.switchTitleTop43 + "报警");
        const switchIdTop44 = this.findDeviceId(this.switchTitleTop44.replace("除湿", "") + "运行时间");
        this.switchDataTop41 = {
          data: currentData[switchIdTop41].value,
          isError: currentData[switchIdTop41].errorLevel,
        };
        this.switchDataTop42 = {
          data: currentData[switchIdTop42].value,
          isError: currentData[switchIdTop42].errorLevel,
          isZh: true,
        };
        this.switchDataTop43 = {
          data: currentData[switchIdTop43].value,
          isError: currentData[switchIdTop43].errorLevel,
          isZh: true,
        };
        this.switchDataTop44 = {
          data: currentData[switchIdTop44].value,
          isError: currentData[switchIdTop44].errorLevel,
          isRunningTime: true,
        };

        const switchIdDown41 = this.findDeviceId(this.switchTitleDown41 + "温度");
        const switchIdDown42 = this.findDeviceId(this.switchTitleDown42 + "温度");
        const switchIdDown43 = this.findDeviceId(this.switchTitleDown43.replace("设定", "温度设定"));
        const switchIdDown44 = this.findDeviceId(this.switchTitleDown44 + "运行");
        const switchIdDown45 = this.findDeviceId(this.switchTitleDown45 + "运行");
        const switchIdDown46 = this.findDeviceId(this.switchTitleDown46.replace("保护", "低压保护"));
        const switchIdDown46B = this.findDeviceId(this.switchTitleDown46.replace("保护", "高压保护"));
        // const switchIdDown47 = this.findDeviceId(this.switchTitleDown47 + "保护");
        const switchIdDown48 = this.findDeviceId(this.switchTitleDown48 + "运行时间");
        this.switchDataDown41 = {
          data: currentData[switchIdDown41].value,
          isError: currentData[switchIdDown41].errorLevel,
          unit: "℃",
        };
        this.switchDataDown42 = {
          data: currentData[switchIdDown42].value,
          isError: currentData[switchIdDown42].errorLevel,
          unit: "℃",
        };
        this.switchDataDown43 = {
          data: currentData[switchIdDown43].value,
          isError: currentData[switchIdDown43].errorLevel,
          unit: "℃",
        };
        this.switchDataDown44 = {
          data: currentData[switchIdDown44].value,
          isError: currentData[switchIdDown44].errorLevel,
        };
        this.switchDataDown45 = {
          data: currentData[switchIdDown45].value,
          isError: currentData[switchIdDown45].errorLevel,
        };
        this.switchDataDown46 = [
          {
            data: currentData[switchIdDown46].value,
            isError: currentData[switchIdDown46].errorLevel,
            isZh: true,
            textOn: "低压",
          },
          {
            data: currentData[switchIdDown46B].value,
            isError: currentData[switchIdDown46B].errorLevel,
            isZh: true,
            textOn: "高压",
          },
        ];
        // this.switchDataDown47 = {
        //   data: currentData[switchIdDown47].value,
        //   isError: currentData[switchIdDown47].errorLevel,
        //   isZh: true,
        // };
        this.switchDataDown48 = {
          data: currentData[switchIdDown48].value,
          isError: currentData[switchIdDown48].errorLevel,
          isRunningTime: true,
        };
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = "除湿机温度";
      let humidityDeviceName = "除湿机湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dehumidifier-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  padding-bottom: 10px;

  // & div {
  //   border: 1px solid;
  // }

  .dehumidifier-main {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
  }

  .column-line {
    width: 100%;
    height: calc(50% - 10px);

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-L {
    width: 100%;
    height: calc(55% - 7px);
    min-height: 380px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-S {
    width: 100%;
    height: calc(45% - 7px);
    min-height: 250px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-XL {
    width: 100%;
    height: calc(75% - 7px);
    min-height: 430px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-XS {
    width: 100%;
    height: calc(25% - 7px);
    min-height: 200px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-full {
    height: 100%;
    min-height: 635px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column {
    width: calc(100% / 4 - 15px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .main-column-small {
    width: calc(100% / 7 - 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-large {
    width: calc(100% / 7 + 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .switch-in-tooltip {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    margin-bottom: 5px;
  }

  .main-column-multi-line {
    width: calc(100% / 4 - 10px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .switch-item-title {
    height: 38px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item-sub-title {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .tooltip-slot {
    line-height: 1.4;
  }
}
</style>
